const DEVICE_ACCESS_STATUS = {
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
}

export { DEVICE_ACCESS_STATUS }
